import React from "react";
import {
  GridContainer,
  GridItem,
  ItemImage,
  ItemLogoSlot,
  ItemTitle,
  ItemCategory,
} from './GridElements';

// 12 divides evenly by 4, 3 and 2, so no ragged final row at any breakpoint.
const HomePageGrid = ({ Projects, limit = 12 }) => {
  const items = (Projects || []).slice(0, limit);

  return (
    <GridContainer>
      {items.map((p, idx) => {
        // Companies still awaiting a logo/site render as a non-clickable tile
        // with the logo slot reserved, rather than a broken image.
        const hasLink = Boolean(p.websiteUrl);
        const linkProps = hasLink
          ? { as: 'a', href: p.websiteUrl, target: '_blank', rel: 'noopener noreferrer' }
          : { as: 'div' };

        return (
          <GridItem key={idx} {...linkProps} $static={!hasLink}>
            {p.image ? (
              <ItemImage src={p.image} alt={`${p.name} logo`} />
            ) : (
              <ItemLogoSlot />
            )}
            <ItemTitle>{p.name}</ItemTitle>
            {p.companyType && <ItemCategory>{p.companyType}</ItemCategory>}
          </GridItem>
        );
      })}
    </GridContainer>
  );
};

export default HomePageGrid;
